import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="分类导航"
          title="按题材挑选你的菜"
          description="从热血到治愈、从科幻到搞笑，六大分类随时切换，快速找到你最爱的那一类漫画。"
          action={
            <Link
              to="/category/blood"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              进入分类 <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => {
            const count = getArticlesByCategory(c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 px-4 py-6 text-center transition-transform hover:-translate-y-1"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={c.icon}></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{c.name}漫画</h3>
                <p className="mt-1 text-xs text-foreground-500">{count} 部人气作品</p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}